import { useState, useEffect, useRef } from 'react'
import { useMount, useUpdateEffect } from 'ahooks'
import { useNavigate, useSearchParams } from 'react-router-dom'
import SearchBar from '@/components/SearchBar/Index'
import ProductList from './components/Products/Products'
import { LeftOutline } from 'antd-mobile-icons'
import { utils, uploadEt, productUtil } from '@/utils'
import { useCorpInfoStore } from '@/stores'
import styles from './Search.module.less'
import { routesMap } from '@/router/routes'
import { useCorpSettingStore } from '@/stores'

import type { RequestParams } from '@/types/product'

const { cloneDeep, px2rem } = utils

function CategorySearch() {
  const { corpInfo } = useCorpInfoStore()
  const { corpSetting } = useCorpSettingStore()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [sortKey, setSortKey] = useState('') // 当前排序 key
  const [sortDirection, setSortDirection] = useState('DESC') // 当前排序方向
  const productHd = useRef<HTMLDivElement>(null)
  const [productHdHeight, setProductHdHeight] = useState(0)
  const [searchText, setSearchText] = useState(searchParams.get('text') || '')
  const [isShowList, setIsShowList] = useState(true)

  // 商品列表搜索分类/推荐相关参数
  const [filter, setFilter] = useState<RequestParams>({
    otherType: 0, // 买过 传 1
    productStatus: 0, // 推荐传 2
    recommendType: 0, // 推荐时传 推荐类型：1 新品 2 爆品 4 促销 99 多货品分享
    categoryId: '0',
    categoryLevel: 0,
    combineType: 0,
    customerId: '0',
    interfaceVersion: 1,
    onScan: false,
    sortDirection: '1',
    sortKey: '5',
    unionMall: 0,
  })

  const onSearch = (text: string) => {
    if (text.length === 0 && searchParams.get('isHome') === '1') {
      setIsShowList(false)
    } else {
      setIsShowList(true)
    }

    setSearchText(text)
  }

  // 初始化
  async function init() {
    const sortOptions = productUtil.initSortOptions(
      corpSetting.cloudProductSort,
      corpSetting.salesOn,
      corpSetting.salesSlipOn,
    ) // 初始化排序选项

    setSortKey(sortOptions.sortActive.activeKey)
    setSortDirection(sortOptions.sortActive.sortDirection as string)
  }

  useMount(async () => {
    if (corpInfo.corpId === '') {
      // 没有企业ID，跳转到 Marketing重新登录游客模式
      navigate(`${routesMap.Marketing}`, { replace: true })
    }

    if (searchParams.get('isHome') === '1') {
      setIsShowList(false)
    }

    uploadEt({ event_type: 9 }) // 埋点，商品分享网页 - 首页打开货品分类结果页次数
    await init()
  })

  useEffect(() => {
    // document.title = t('全部货品')
    if (productHd.current) {
      setProductHdHeight(productHd.current.offsetHeight)
    }
  }, [])

  // 设置请求参数
  useUpdateEffect(() => {
    filter.combineType = 0
    filter.sortKey = sortKey
    filter.sortDirection = sortDirection === 'ASC' ? '0' : '1'
    filter.dataValue = searchParams.get('dataValue')
    filter.dataType = searchParams.get('dataType')
    filter.sort = searchParams.get('sort')
    filter.searchText = searchText
    setFilter(cloneDeep(filter))
  }, [sortDirection, sortKey, searchText])

  return (
    <>
      <div className={styles['product-container']}>
        <div className={styles['product-hd']} ref={productHd}>
          <div className={styles['searchbar-box']}>
            <LeftOutline
              fontSize={px2rem(28)}
              color="#222"
              onClick={() => navigate(-1)}
            />
            <SearchBar
              className={styles['search-bar']}
              enableSearch={true}
              onSearch={onSearch}
              isShowScan={false}
            />
          </div>
        </div>
        <div
          className={styles['product-bd']}
          style={{ height: `calc(100% - ${productHdHeight}px)` }}
        >
          <div className={styles['product-list']}>
            <div className={styles['product-list-container']}>
              {isShowList && <ProductList requestParams={filter} />}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CategorySearch
